import React, { useContext, useMemo } from 'react';
import { css } from 'styled-components';
import moment from 'moment';
import { API_DATE_FORMAT } from '@ubeya/shared/constants';
import { getEmployeeDisplayName } from '@ubeya/shared-web/utils/employee';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { PDFTable, PDFTitle } from 'shared/components';

const tableStyle = css`
  td * {
    font-size: 11px !important;
    padding: 0;
  }
`;

const TimeSheetPDF = ({ data, columns, onClose }) => {
  const { t } = useContext(ConfigContext);
  const { dateFormat, isShowLastNameFirst = false } = useContext(ConfigContext);

  const filteredColumns = useMemo(() => {
    const cellFormatter = {
      name: (_, { employee: { firstName, lastName } }) =>
        getEmployeeDisplayName(firstName, lastName, isShowLastNameFirst)
    };

    const filtered = columns.filter((column) => column && column.Header && column.dataKey !== 'details');

    const added = filtered.find(({ Header }) => Header === t('date'))
      ? filtered
      : [
          {
            Header: t('date'),
            dataKey: 'date',
            formatter: (value) => value && moment(value, API_DATE_FORMAT).format(`${dateFormat}, ddd`)
          },
          ...filtered
        ];

    return added.map((column) =>
      cellFormatter[column.dataKey]
        ? {
            ...column,
            Cell: undefined,
            formatter: cellFormatter[column.dataKey]
          }
        : column
    );
  }, [columns, dateFormat, isShowLastNameFirst, t]);

  const visibleData = useMemo(
    () => data.reduce((prev, { subRows }) => [...prev, ...subRows.filter(({ dummy }) => !dummy)], []),
    [data]
  );

  return (
    <PDFTable
      asksColumns
      storageName="timesheet-pdf"
      name={t('timesheet')}
      header={<PDFTitle title={t('timesheet')} />}
      columns={filteredColumns}
      data={visibleData}
      onClose={onClose}
      tableStyle={tableStyle}
    />
  );
};

export default TimeSheetPDF;
